import DailyTOURateOverview from './DailyTOURateOverview'

const TimeOfUseOverview = ({ seasonalRateSummary }) => {
  return <DailyTOURateOverview fullSeasonalRateSummary={seasonalRateSummary} />
}

export default TimeOfUseOverview
